/*
 * サブシステム名：
 * 機能名：かんたん日報入力
 * 表示項目カスタマイズSP(滋賀自工)
 */

import D2PRMD0040 from '@/views/PRM/D2PRMD0040.js'
import filter from '@/rahmen/utils/filters'
import date from '@/ddv2.library/date'
import indexeddb from '@/ddv2.library/indexeddb'
import fraction from '@/ddv2.library/fraction'

export default ({
  extends: D2PRMD0040,
  name: 'NippoEasyEditCustomForSGJSp',
  data: () => ({
    customJuchuRirekiHeaders: [
      { text: '', value: 'actions', align: 'center' },
      { text: '受注営業所', value: 'juchuEigyoshoNm' },
      { text: '荷主', value: 'tokuisakiNm' },
      // { text: '注文番号', value: 'chumonNo' },
      { text: '発地', value: 'hatsuchiDisp' },
      { text: '着地', value: 'chakuchiDisp' },
      { text: '発地年月日', value: 'hatsuchiYmdDisp' },
      { text: '発地時刻', value: 'hatsuchiHmsDisp' },
      { text: '着地', value: 'chakuchiDisp' },
      { text: '着地年月日', value: 'chakuchiYmdDisp' },
      { text: '着地時刻', value: 'chakuchiHmsDisp' },
      { text: '走行距離', value: 'yoteiSokoKyoriDisp' },
      { text: '現場名', value: 'hinmeiDisp' },
      { text: '数量', value: 'juchuSuryoDisp', align: 'end' },
      { text: '単位', value: 'unitKbnNm' },
      { text: '重量(t)', value: 'juchuJuryoDisp', align: 'end' },
      { text: '単価', value: 'tankaDisp' },
      { text: '請求計上日', value: 'seikyuYoteiYmdDisp' },
      { text: '運賃計算区分', value: 'unchinKeisanKbnNm' },
      { text: '請求車種', value: 'seikyuShashuSbtNm' },
      { text: '運賃', value: 'kihonUnchinDisp', align: 'end' },
      { text: '高速代', value: 'hiwayPriceDisp', align: 'end' },
      { text: 'その他課税', value: 'unchinHokaKingakuDisp', align: 'end' },
      { text: 'その他非課税', value: 'unchinHokaHikazeiDisp', align: 'end' },
      { text: '売上金額', value: 'uriageKingakuDisp', align: 'end' },
      { text: '待機時間', value: 'taikiJikanDisp', align: 'center' },
      { text: '待機時間単価', value: 'taikiJikanTankaDisp', align: 'end' },
      { text: '待機時間料', value: 'taikiJikanKingakuDisp', align: 'end' },
      { text: '割増金額(時間)', value: 'jikanWarimashiKingakuDisp', align: 'end' },
      { text: '割増金額(距離)', value: 'kyoriWarimashiKingakuDisp', align: 'end' },
      { text: '割増その他', value: 'warimashiSonotaKingakuDisp', align: 'end' },
      { text: '傭車額', value: 'yoshaKihonUnchinDisp', align: 'end' },
      { text: '傭車高速代', value: 'yoshaHiwayPriceDisp', align: 'end' },
      { text: '傭車その他課税', value: 'yoshaUnchinHokaKingakuDisp', align: 'end' },
      { text: '傭車その他非課税', value: 'yoshaUnchinHokaHikazeiDisp', align: 'end' },
      { text: '請求用備考', value: 'seikyuBiko' },
      { text: '連絡用備考', value: 'renrakuBiko' }
    ],
    customTeikeiCorseHeaders: [
      { text: '', value: 'actions', align: 'center' },
      { text: 'コースNo', value: 'teikeiCourseNo' },
      { text: 'コース名称', value: 'teikeiCourseNm' },
      { text: '荷主', value: 'tokuisakiNm' },
      { text: '発地', value: 'hatsuchiDisp' },
      { text: '発時刻', value: 'hatsuchiHmsDisp' },
      { text: '着地', value: 'chakuchiDisp' },
      { text: '着時刻', value: 'chakuchiHmsDisp' },
      { text: '走行距離', value: 'yoteiSokoKyoriDisp' },
      { text: '請求車種', value: 'seikyuShashuSbtNm' },
      { text: '運賃計算方法', value: 'unchinKeisanKbnNm' },
      { text: '数量', value: 'juchuSuryo', align: 'end' },
      { text: '単位', value: 'unitKbnNm' },
      { text: '重量', value: 'juchuJuryo', align: 'end' },
      { text: '単価', value: 'tanka', align: 'end' },
      { text: '運賃', value: 'kihonUnchin', align: 'end' },
      { text: '高速代', value: 'hiwayPrice', align: 'end' },
      { text: 'その他課税', value: 'unchinHokaKingaku', align: 'end' },
      { text: 'その他非課税', value: 'unchinHokaHikazei', align: 'end' },
      { text: '待機時間', value: 'taikiJikanDisp', align: 'center' },
      { text: '待機時間単価', value: 'taikiJikanTanka', align: 'end' },
      { text: '待機時間料', value: 'taikiJikanKingaku', align: 'end' },
      { text: '時間割増金額', value: 'jikanWarimashiKingaku', align: 'end' },
      { text: '距離割増金額', value: 'kyoriWarimashiKingaku', align: 'end' },
      { text: '割増その他', value: 'warimashiSonotaKingaku', align: 'end' },
      { text: '請求金額合計', value: 'seikyuGokei', align: 'end' },
      { text: '売上金額', value: 'uriageKingaku', align: 'end' },
      { text: '請求用備考', value: 'seikyuBiko' },
      { text: '連絡用備考', value: 'renrakuBiko' },
      { text: '支払運賃', value: 'yoshaUnchin', align: 'end' },
      { text: '支払運賃(高速)', value: 'yoshaHiwayPrice', align: 'end' },
      { text: '支払その他課税', value: 'yoshaUnchinHokaKingaku', align: 'end' },
      { text: '支払その他非課税', value: 'yoshaUnchinHokaHikazei', align: 'end' },
      { text: '支払金額合計', value: 'shiharaiGokei', align: 'end' },
      { text: '支払用備考', value: 'shiharaiBiko' }
    ],
    helpUseFlg: false
  }),
  computed: {
    customFilteredTeikeiCourseList () {
      return this.teikeiCourseList.map((elem) => {
        if (elem.tokuisakiId) { elem.tokuisakiDisp = elem.tokuisakiNm }
        elem.hinmeiDisp = elem.mstHinmeiId ? elem.hinmeiNm : elem.hinmeiBiko
        elem.hatsuchiDisp = elem.hatsuchiId ? elem.hatsuchiNm : elem.hatsuchiBiko
        elem.chakuchiDisp = elem.chakuchiId ? elem.chakuchiNm : elem.chakuchiBiko
        elem.keiyuchiId1Disp = elem.keiyuchiId1 ? elem.keiyuchiId1Nm : elem.keiyuchiId1Biko
        if (elem.tantoEigyoshoId) { elem.tantoEigyoshoDisp = elem.tantoEigyoshoCd + ' : ' + elem.tantoEigyoshoNm }
        elem.hatsuchiHmsDisp = elem.hatsuchiHms ? (elem.hatsuchiHms).slice(0, 5) : elem.hatsuchiHmsBiko
        elem.chakuchiHmsDisp = elem.chakuchiHms ? (elem.chakuchiHms).slice(0, 5) : elem.chakuchiHmsBiko
        elem.yoteiSokoKyoriDisp = elem.yoteiSokoKyori ? filter.numericFormatter(elem.yoteiSokoKyori) + ' km' : null
        if (elem.juchuSuryo) { elem.juchuSuryo = filter.numericFormatter(elem.juchuSuryo) }
        if (elem.juchuJuryo) { elem.juchuJuryo = filter.numericFormatter(elem.juchuJuryo) }
        if (elem.tanka) { elem.tanka = filter.numericFormatter(elem.tanka) }
        elem.hacchakuNm = [undefined, null, ''].includes(elem.hatsuchiDisp) && [undefined, null, ''].includes(elem.chakuchiDisp) ? '' : elem.hatsuchiDisp + ' ⇒ ' + elem.chakuchiDisp
        /*
        elem.hacchakuNm = !elem.hatsuchiNm && !elem.hatsuchiBiko && !elem.chakuchiNm && !elem.chakuchiBiko
          ? '' : (elem.hatsuchiId ? elem.hatsuchiNm : elem.hatsuchiBiko) + ' ⇒ ' + (elem.chakuchiId ? elem.chakuchiNm : elem.chakuchiBiko)
        */
        return elem
      }).sort((a, b) => {
        if (a.teikeiCourseNo < b.teikeiCourseNo) { return -1 }
        if (a.teikeiCourseNo > b.teikeiCourseNo) { return 1 }
        return 0
      })
    }
  },
  methods: {
    inputUnkoYmd: function (e) {
      this.recHaisoMeisai.seikyuYoteiYmd = this.viewsData.vwUnkoJisseki.unkoYmd
      this.recHaisoMeisai.shiharaiYoteiYmd = this.viewsData.vwUnkoJisseki.unkoYmd
    },
    initBindVariables: function () {
      this.setHeaders()
      this.widthOfLineHeader = [0, 0, 0]
      // 基準日初期値設定
      this.baseYmd = date.getCurrentDate()
      // this.modeKengen = 0
      this.deleteMode = 0
      // this.modeOfEdit = 0
      this.kakuninzumiMode = false
      this.seikyuZumiMode = false
      this.shiharaiZumiMode = false
      this.haishaEigyoshoCd = this.usersEigyosho
      this.jishaSharyoSbt = null
      this.yoshaSharyoSbt = null
      this.tempViewsData = {}
      this.lastUnkoJissekiInfo = {}
      this.jiEigyoshoId = this.eigyoshoList.length > 0 ? indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyosho, this.baseYmd).id : null
      const initData = {
        vwUnkoJisseki: {
          unkoYmd: filter.dateFormatter(new Date()),
          haishaKbn: '02',
          sharyoId: null,
          hacchusakiShaban: null,
          hacchusakiShashuSbt: null,
          hatsuchiOdoMater: '',
          chakuchiOdoMater: '',
          sokoKyori: 0,
          jisshaKyori: 0,
          jissekiShukkoYmd: '',
          jissekiShukkoHms: '',
          jissekiKikoYmd: '',
          jissekiKikoHms: '',
          hacchusakiId: null,
          hacchusakiJomuinId: null
        },
        vwSagyoJisseki: {
          jissekiKakuninZumiFlg: false,
          torokuTantoshaId: this.usersId,
          eigyoshoId: this.eigyoshoList.length > 0 ? indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyosho, this.baseYmd).id : null
        },
        vwKintaiJissekiJomuin: {
          jininId: this.usersId,
          shukkinYmd: null,
          shukkinHms: null,
          taikinYmd: null,
          taikinHms: null,
          kosokuJikan: null,
          kyukeiJikan: null,
          kadouJikan: null,
          kinmuTeateKingaku1: null,
          kinmuTeateKingaku2: null,
          kinmuTeateKingaku3: null,
          kinmuTeateKingaku4: null,
          kinmuTeateKingaku5: null
        },
        vwKintaiJissekiJoshu: {
          jininId: '',
          shukkinYmd: null,
          shukkinHms: null,
          taikinYmd: null,
          taikinHms: null,
          kosokuJikan: null,
          kyukeiJikan: null,
          kadouJikan: null,
          kinmuTeateKingaku1: null,
          kinmuTeateKingaku2: null,
          kinmuTeateKingaku3: null,
          kinmuTeateKingaku4: null,
          kinmuTeateKingaku5: null
        },
        vwHaisoMeisai: [],
        trSagyoKeikakuJininList: [],
        trSagyoKeikakuMeisaiList: [],
        vwSharyoKeihiNenryohi: [],
        vwSharyoKeihiTsukoryo: []
      }
      this.viewsData = Object.assign({}, initData)
      this.initHaisoMeisai()
      // this.$refs.seikyuYoteiYmd.onCalendarInput(filter.dateFormatter(new Date()))
      this.recNenryo = {}
      this.recTsukoryo = {}
      this.recNenryo.torihikisakiId = null
      this.registerMode = 0
      this.isJishaHaishaMode = true
      this.isJiEigyoshoMode = true
      this.isHokaEigyoshoMode = false
      this.isHaisoMeisaiRequired = true
      this.expandKeiyuchi = false
      // 権限制御
      this.isReadOnlyCommon = false
      this.isReadOnlyJisha = false
      this.isReadOnlyYosha = false
    },
    inputOdoMater: function () {
      if (this.viewsData.vwUnkoJisseki.hatsuchiOdoMater && this.viewsData.vwUnkoJisseki.chakuchiOdoMater) {
        let hatsuchiOdoMater = this.viewsData.vwUnkoJisseki.hatsuchiOdoMater
        let chakuchiOdoMater = this.viewsData.vwUnkoJisseki.chakuchiOdoMater

        if (hatsuchiOdoMater === undefined || hatsuchiOdoMater === '' || hatsuchiOdoMater === null) { hatsuchiOdoMater = 0 }
        if (chakuchiOdoMater === undefined || chakuchiOdoMater === '' || chakuchiOdoMater === null) { chakuchiOdoMater = 0 }

        const calcSokoKyori = Math.floor(fraction.calcSubtract(parseFloat(chakuchiOdoMater), parseFloat(hatsuchiOdoMater)) * 10) / 10
        this.$set(this.viewsData.vwUnkoJisseki, 'sokoKyori', calcSokoKyori)
        this.inputJissekiKyori()
      }
    },
    inputJissekiKyori: function () {
      let sokoKyori = this.viewsData.vwUnkoJisseki.sokoKyori
      let jisshaKyori = this.viewsData.vwUnkoJisseki.jisshaKyori
      let kushaKyori = this.viewsData.vwUnkoJisseki.kushaKyori

      if (sokoKyori === undefined || sokoKyori === '' || sokoKyori === null) { sokoKyori = 0 }
      if (jisshaKyori === undefined || jisshaKyori === '' || jisshaKyori === null) { jisshaKyori = 0 }
      if (kushaKyori === undefined || kushaKyori === '' || kushaKyori === null) { kushaKyori = 0 }

      let calcKyori = 0

      calcKyori = Math.floor(fraction.calcSubtract(sokoKyori, kushaKyori) * 10) / 10
      this.$set(this.viewsData.vwUnkoJisseki, 'jisshaKyori', calcKyori)
      this.$set(this.viewsData.vwUnkoJisseki, 'kushaKyori', kushaKyori)
    }
  }
})
